import { faSquare } from '@fortawesome/free-regular-svg-icons'
import { faGripLinesVertical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button as AntButton, Col, Flex, Grid, Row, Space } from 'antd'
import { GetInTouch } from 'components/pages'
import { Button, Container, Loading } from 'components/ui'
import ProductCard from 'components/ui/productCard/ProductCard'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import CategoryHeader from '../components/categoryHeader/CategoryHeader'
import Collection from '../components/Collection'
import useCategoriesContext from '../services/categoriesContext'
import '../styles/Categories.css'

const { useBreakpoint } = Grid

const Categories = () => {
  const [grid, setGrid] = useState<12 | 24>(12)
  const { t, i18n } = useTranslation()
  const screens = useBreakpoint()

  const language = useMemo(
    () => i18n.language as 'uz' | 'ru' | 'en',
    [i18n.language]
  )

  const {
    state: { data, loading }
  } = useCategoriesContext()
  return (
    <div>
      {loading ? (
        <Loading mode="dark" />
      ) : (
        <>
          <CategoryHeader />
          <Container size="xxl">
            {data?.data?.map((category) => (
              <div style={{ margin: '50px 0' }}>
                <Flex
                  justify="space-between"
                  align="center"
                  style={{ marginBottom: '20px' }}
                >
                  <h3 className="jetbrains-mono">{category.name[language]}</h3>
                  {((screens.sm === true && screens.md === false) ||
                    screens.xs) && (
                    <Space>
                      <AntButton
                        type={grid === 24 ? 'primary' : 'default'}
                        icon={<FontAwesomeIcon icon={faSquare} />}
                        onClick={() => setGrid(24)}
                      />
                      <AntButton
                        type={grid === 12 ? 'primary' : 'default'}
                        icon={<FontAwesomeIcon icon={faGripLinesVertical} />}
                        onClick={() => setGrid(12)}
                      />
                    </Space>
                  )}
                </Flex>
                <Row gutter={[20, 20]}>
                  {category.products?.map((product) => (
                    <Col xs={grid} sm={grid} md={8} lg={6}>
                      <ProductCard {...product} />
                    </Col>
                  ))}
                </Row>
                {(category.products?.length ?? 0) > 9 && (
                  <Link to={`/products/${category._id}`}>
                    <Button
                      type="contained-gradient"
                      style={{
                        display: 'block',
                        margin: 'auto',
                        marginTop: '20px'
                      }}
                    >
                      {t('categories.see_all')}
                    </Button>
                  </Link>
                )}
              </div>
            ))}
          </Container>
          <Collection />
        </>
      )}
      <GetInTouch />
    </div>
  )
}

export default Categories
